import { useEffect, useState } from "react";
import { SimpleGrid, VStack, Spinner } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import useSetPageHeader from "@/components/hooks/useSetPageHeader";
import { HiOutlineCpuChip } from "react-icons/hi2";
import ModelCard from "@/components/ui/ModelCard";
import { ModelService } from "@/services/ModelService";

const ModelsPage = () => {
    const { t } = useTranslation("models");
    useSetPageHeader(t("modelsPage.headerTitle"), t("modelsPage.headerSubtitle"), <HiOutlineCpuChip />);
    const [models, setModels] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        ModelService.getAll().then((response) => {
            setModels(response?.items ?? []);
            setIsLoading(false);
        });
    }, []);

    if (isLoading) {
        return <Spinner color="brand.400" size="lg" />;
    }

    return (
        <VStack w="full" py={6} alignItems="flex-start" gap={4}>
            <SimpleGrid columns={{ base: 1, sm: 2 }} gap={4} w="full">
                {models.map((model) => (
                    <ModelCard
                        key={model.id}
                        title={model.name}
                        status={false}
                        description={model.description}
                        avatarUrl="https://placehold.co/80x80/22c55e/white?text=AI"
                        buttonUrl={`/models/${model.id}`}
                    />
                ))}
            </SimpleGrid>
        </VStack>
    );
};

export default ModelsPage;
